import { connect } from "react-redux";
import VirtualStagingCategories from "./virtual_staging_categories";
import React from "react";
import { withRouter } from "react-router-dom"

const msp = (state, ownProps) => ({
  errors: Array.isArray(state.errors?.session) ? state.errors?.session : [],
  categories: Object.values(state.entities.virtualStaging.categories)
});

const mdp = (dispatch) => ({
});

export default withRouter(connect(msp, mdp)(VirtualStagingCategories));